import { FlexCenterWrapper } from "./DefaultNoDataWrapper";
import Flex from "./Flex";
import Text from "./Text";
// import noDataImg from "/default-images/no Data Found.svg";

type NoDataAvailableProps = {
  message?: string;
  size?: number;
};

export const NoDataAvailable = ({
  message,
  // size = 120,
}: NoDataAvailableProps) => (
  <Flex width={"100%"} height={"inherit"}>
    <FlexCenterWrapper>
      {/* <img
        src={noDataImg}
        height={size}
        width={size}
        alt={"No Data Available"}
      /> */}
      <Text>{message || "No Data Available"}</Text>
    </FlexCenterWrapper>
  </Flex>
);
